export default {
    formId: 'permissionsForm',
    formField: {
        name: {
            name: 'name',
            label: 'Nombre',
            type: 'text',
            requiredErrorMsg: 'El nombre es requerido'
        },
        icon: {
            name: 'icon',
            label: 'Icono (Material UI)',
            type: 'text',
            requiredErrorMsg: 'El icono es requerido'
        },
        slug: {
            name: 'slug',
            label: 'Slug',
            type: 'text',
            requiredErrorMsg: 'El slug es requerido'
        },
        description: {
            name: 'description',
            label: 'Descripción',
            type: 'text',
            requiredErrorMsg: 'La descripción es requerida'
        },
        application_id: {
            name: 'application_id',
            label: 'Aplicación',
            type: 'select',
            requiredErrorMsg: 'La aplicación es requerida'
        },
        childrens: {
            name: 'childrens',
            label: 'Estructura de hijos (Formato JSON)',
            type: 'text',
            requiredErrorMsg: 'El JSON es requerido'
        }
    }
}
